import events from 'events'

const notifMsg = 'NOTIF_MSG';

let AppDispatcher = new events.EventEmitter();

export default AppDispatcher;

export const actions = {notifMsg};


// WEBPACK FOOTER //
// ./shared/dispatcher/AppDispatcher.js